import vue from 'vue';

export default function buildProductStore(store){
    store.actions.getCustomsInfo = async (context, params) => await vue.prototype.$myHttp.post('/api/products/getCustomsInfo', params);
    return store;
}